export default __webpack_public_path__ + "static/media/les_andelys06.b65332f6.jpg";